import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-45affe1c")

_pushScopeId("data-v-45affe1c")
const _hoisted_1 = { class: "input-number" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("input", {
      type: "number",
      value: _ctx.innerValue,
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.tryUpdate && _ctx.tryUpdate(...args))),
      disabled: _ctx.disabled,
      min: _ctx.minValue,
      max: _ctx.maxValue,
      onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.context.emit('focus'))),
      onBlur: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.commit && _ctx.commit(...args)))
    }, null, 40, ["value", "disabled", "min", "max"]),
    (_ctx.suffix)
      ? (_openBlock(), _createBlock("span", {
          key: 0,
          class: { disabled: _ctx.disabled }
        }, _toDisplayString(_ctx.suffix), 3))
      : _createCommentVNode("", true)
  ]))
})